import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactLoading from 'react-loading';
import { primarycolor } from "../Utils/colors";
import { Changedpurl, Changepassurl, Fetchmessagesurl, Postmessagesurl, Readmessageurl, Savedetailsurl, Singlehouseurl, Unreadmessagesurl } from "./../Utils/urls";
import styles from "./../Hostels/houses.module.css";
import styless from './style.module.css';
import { FaSignOutAlt, FaBeer, FaBars, FaTimes, FaAndroid, FaBell, FaFacebookMessenger, FaStarOfLife, FaUser, FaClock, FaIdCard, FaLocationArrow, FaQuestionCircle, FaFile, FaStar, FaTrash, FaHandHoldingWater, FaChalkboard, FaBath, FaLaptopHouse, FaBoxTissue, FaShower, FaWifi, FaToriiGate, FaChair, FaChessBoard, FaBed, FaMapMarker, FaMapMarkerAlt, FaPhoneAlt, FaHouseUser, FaPlusCircle, FaCheckCircle, FaUpload, FaForward, FaTimesCircle, FaFacebook, FaTwitter, FaWhatsapp, FaYoutube, FaInstagram } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from "react-router-dom";
import Searchlinks from "../Utils/links";
import { scroller } from "react-scroll";
import Backdrop from '@mui/material/Backdrop';
import { getsessionuser, setsessionuser, logoutuser, getsessionhouse, setsessionhouse } from './../Utils/sessions';
import Loginpopup from "../Components/loginpopup";
import { isDesktop } from "react-device-detect";
import Universalheader from "../Headers/universalheader";





let color = "blue";
let type = "spokes";


const Chats = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const messagef = location.state?.message;
    const bizphone = location.state?.phone;

    const sessionuser = getsessionuser();
    const sessionhouse = getsessionhouse();
    const [user, setuser] = useState(sessionuser);
   
    const [fetchedmessages, setfetchedmessages] = useState([]);
    const [startchat, setstartchat] = useState(messagef ? true : false);
    const [message, setmessage] = useState(`${location.state?.items} ${bizphone ? 'contact ' + bizphone : ""}`);

    const [showsingleconversation, setshowsingleconversation] = useState(false);
    const [displayedmessages, setdisplayedmessages] = useState('');


    const [currentdate, setcurrentdate] = useState(new Date());

    // const Details = landlorduser && landlorduser;
    const [Details, setDetails] = useState(sessionhouse && sessionhouse);

    const mydetails = user && user;

    //message states
    //statuses of both the sender and the recepient inboxes
    const [messagestatus, setmessagestatus] = useState(false);
    const [mymessagestatus, setmymessagestatus] = useState(false);
    const [loading, setloading] = useState(true);
    const [error, seterror] = useState('');
    const [allmessages, setallmessages] = useState(messagef ? false : true);
    const [randomcolor, setrandomcolor] = useState('');

  

    const [success, setsuccess] = useState(false);




    var time = currentdate.getHours() + ":" + currentdate.getMinutes();
    var date = currentdate.getDate() + "/" + (currentdate.getMonth() + 1) + "/" + currentdate.getFullYear();

    // setInterval(() => {
    //     var currentdate = new Date();
    //     setcurrentdate(currentdate)
    // }, 10000);




    useEffect(() => {
        getmessages();
        getcolor();
        getfirstmymessages();

        const interval = setInterval(() => {
            getfirstmymessages();
        }, 1000);
        return () => clearInterval(interval);
    }, []);



    //getcolor
    const getcolor = () => {
        var randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
        setrandomcolor(randomColor)
    }

    //read message
    const readmessage = () => {
        axios.post(Readmessageurl, {
            email: user?.email
        }).then(response => {
            if (!response.data.message) {
            } else {
                // seterror(response.data.message)
            }
            // 
        }).catch(error => {

        });
    }


    //get  recipient messages
    const getmessages = async () => {
        axios.post(Fetchmessagesurl, {
            email: Details?.email
        }).then(response => {
            setloading(false)
            if (!response.data.message) {
                if (response.data.messages) {
                    setmessagestatus(true)
                    //getfirstmymessages();
                } else {
                    setmessagestatus(false)
                    getfirstmymessages();
                }
            } else {
                setmessagestatus(false)
            }
            // 
        }).catch(error => {
            seterror("There was an error try again later")

        });
    }

    //get my messages to check whether my messages field is empty
    const getfirstmymessages = async () => {
        axios.post(Fetchmessagesurl, {
            email: mydetails?.email
        }).then(response => {
            if (!response.data.message) {
                //setmymessagestatus(true)
                if (response.data.messages) {
                    setmymessagestatus(true)
                    setfetchedmessages(response.data.messages)
                } else {
                    setmymessagestatus(false)
                }
            } else {
                setmymessagestatus(false)
            }
            // 
        }).catch(error => {
            seterror("There was an error try again later")

        });

    }


    //check if message is empty and if the emails to send and receive are the same
    const check = () => {
        setloading(true)
        seterror(null)
        if (Details.email === mydetails.email) {
            seterror("You cannot send a message to yourself")
            setloading(false)
        } else {
            if (!message) {
                seterror("Cannot send an empty message")
                setloading(false)
            } else {
                //fetch recipients messages again
                getsecondmessages();
            }
        }

    }


    //get recipients messages again to avoid lost messages
    const getsecondmessages = async () => {
        axios.post(Fetchmessagesurl, {
            email: Details.email
        }).then(response => {
            if (!response.data.message) {
                if (response.data.messages) {
                    //fetch my messages to update the messages field
                    mygetmessages(response.data.messages)
                } else {
                    mygetmessages(["none"]);
                }
            } else {
                setloading(false)
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("There was an error try again later")
        });

    }

    //get my messages too again
    const mygetmessages = async (e) => {
        axios.post(Fetchmessagesurl, {
            email: mydetails.email
        }).then(response => {
            if (!response.data.message) {
                if (response.data.messages) {
                    updateboth(e, response.data.messages)
                } else {
                    updateboth(e, ["none"])
                }
            } else {
                setloading(false)
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("There was an error try again later")

        });

    }




    //update the mesaages before uploading to both the sender and the recipient
    const updateboth = (recipientmessages, mymessages) => {
        const singlemessage = { message: message, time: time, date: date, designation: "Nme" };
        const mysinglemessage = { message: message, time: time, date: date, designation: "me" }

        if (messagestatus) {//if fetched messages is not empty
            //check if a chat exists

            var index = recipientmessages.findIndex(obj => obj?.email == mydetails.email && obj.deletestatus !== "true");
            var index2 = mymessages.findIndex(obj => obj?.email == Details.email && obj.deletestatus !== "true");

            if (index !== -1) {//if it exists
                if (index2 !== -1) {//if his details exist in my inbox too
                    recipientmessages[index].messages.push(singlemessage)
                    mymessages[index2].messages.push(mysinglemessage)
                    sendmessage(recipientmessages, mymessages);
                } else {//if his details does not exist in my inbox
                    //My message to my account under his name
                    const mymessageObj = { phone: Details.phone, email: Details.email, username: Details.username, url: Details.ownerurl, messages: [mysinglemessage], deletestatus: "false" };
                    mymessages.unshift(mymessageObj)
                    recipientmessages[index].messages.push(singlemessage)
                    sendmessage(recipientmessages, mymessages);
                }
            }
            else {//if it does not exist
                //my message to recepient account 
                const messageObj = { phone: mydetails.phone, email: mydetails.email, username: mydetails.username, url: mydetails.url, messages: [singlemessage], deletestatus: "false" };
                //My message to my account under his name
                const mymessageObj = { phone: Details.phone, email: Details.email, username: Details.username, url: Details.ownerurl, messages: [mysinglemessage], deletestatus: "false" };

                if (mymessagestatus) {//if my inbox is not empty as well

                    if (index2 !== -1) {//if his details exist in my inbox too but not mine in his
                        mymessages[index2].messages.push(mysinglemessage)
                        recipientmessages.unshift(messageObj)
                        sendmessage(recipientmessages, mymessages);
                    } else { // if both our inboxes do not have any of each of our records
                        recipientmessages.unshift(messageObj)
                        mymessages.unshift(mymessageObj)
                        sendmessage(recipientmessages, mymessages);
                    }

                } else {//if my inbox is empty but his inbox is not
                    recipientmessages.unshift(messageObj)
                    //My message to my account under his name
                    const mymessageObj = { phone: Details.phone, email: Details.email, username: Details.username, url: Details.ownerurl, messages: [mysinglemessage], deletestatus: "false" };
                    const myinbox = [mymessageObj];
                    sendmessage(recipientmessages, myinbox)
                }

            }

        } else {//if fetched messages is empty
            //my message to recepient account 
            const messageObj = { phone: mydetails.phone, email: mydetails.email, username: mydetails.username, url: mydetails.url, messages: [singlemessage], deletestatus: "false" };
            //My message to my account under his name
            const mymessageObj = { phone: Details.phone, email: Details.email, username: Details.username, url: Details.ownerurl, messages: [mysinglemessage], deletestatus: "false" };

            if (mymessagestatus) {//if my inbox is not empty  but his inbox is 
                // var index = recipientmessages.findIndex(obj => obj?.email == mydetails.email);
                var index2 = mymessages.findIndex(obj => obj?.email == Details.email && obj.deletestatus !== "true");

                if (index2 !== -1) {
                    mymessages[index2].messages.push(mysinglemessage)
                    const recipientmessages = [messageObj];
                    sendmessage(recipientmessages, mymessages);

                } else {
                    const recipientmessages = [messageObj];
                    mymessages.unshift(mymessageObj)
                    sendmessage(recipientmessages, mymessages);
                }
            } else {
                const recipientmessages = [messageObj];
                const mymessages = [mymessageObj]
                sendmessage(recipientmessages, mymessages);
            }
        }
    }


    //send message
    const sendmessage = (recipientmessages, mymessages) => {

        axios.post(Postmessagesurl, {
            email1: Details.email,
            messages1: recipientmessages,
            email2: mydetails.email,
            messages2: mymessages

        }).then(response => {
            setloading(false)
            if (!response.data.message) {
                if (response.data.success) {
                    setshowsingleconversation(false)
                    setstartchat(false)
                    getfirstmymessages();
                    setallmessages(true)
                    setmessage("")
                } else {
                    seterror("There was an internal error contact admin")
                }
            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("There was an error try again later")
        });
    }

    const logout = () => {
        setOpen(true)
    }

    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    //check if message is empty and if the emails to send and receive are the same
    const check2 = () => {
        setloading(true)
        seterror(null)
        if (Details.email === mydetails.email) {
            setloading(false)
            seterror("You cannot send a message to yourself")
        } else {
            if (!message) {
                setloading(false)
                seterror("Cannot send an empty message")
            } else {
                //fetch recipients messages again
                getsecondmessages2();
            }
        }

    }

    //get recipients messages again to avoid lost messages 
    const getsecondmessages2 = async () => {
        axios.post(Fetchmessagesurl, {
            email: Details.email
        }).then(response => {
            if (!response.data.message) {
                if (response.data.messages) {
                    //fetch my messages to update the messages field
                    mygetmessages2(response.data.messages)
                } else {
                    setloading(false)
                    seterror("There was an internal error.try again later")
                }
            } else {
                setloading(false)
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("There was an error try again later")

        });

    }


    //get my messages
    const mygetmessages2 = async (e) => {
        axios.post(Fetchmessagesurl, {
            email: mydetails.email
        }).then(response => {
            if (!response.data.message) {
                if (response.data.messages) {
                    updateboth2(e, response.data.messages)

                } else {
                    setloading(false)
                    seterror("There was an internal error.try again later")
                }
            } else {
                setloading(false)
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("There was an error try again later")

        });

    }

    //update the mesaages before uploading to both the sender and the recipient
    const updateboth2 = (recipientmessages, mymessages) => {

        const singlemessage = { message: message, time: time, date: date, designation: "Nme" };
        const mysinglemessage = { message: message, time: time, date: date, designation: "me" }

        //my message to recipient account 
        const messageObj = { phone: mydetails.phone, email: mydetails.email, username: mydetails.username, url: mydetails.url, messages: [singlemessage], deletestatus: "false" };
        //My message to my account under his name
        const mymessageObj = { phone: Details.phone, email: Details.email, username: Details.username, url: Details.ownerurl, messages: [mysinglemessage], deletestatus: "false" };

        //Get location of the messages in each inbox
        var index = recipientmessages.findIndex(obj => obj?.email == mydetails.email && obj.deletestatus !== "true");
        var index2 = mymessages.findIndex(obj => obj?.email == Details.email && obj.deletestatus !== "true");

        if (index !== -1) {
            if (index2 !== -1) {//if both our inboxes has our messages
                recipientmessages[index].messages.push(singlemessage)
                mymessages[index2].messages.push(mysinglemessage)
                sendmessage2(recipientmessages, mymessages);
            } else {
                mymessages.unshift(mymessageObj)
                recipientmessages[index].messages.push(singlemessage)
                sendmessage2(recipientmessages, mymessages);
            }
        } else {
            if (index2 !== -1) {//if his inbox does not contain my messages but mine contains his 
                recipientmessages.unshift(messageObj)
                mymessages[index2].messages.push(mysinglemessage)
                sendmessage2(recipientmessages, mymessages);
            } else {//if both our inboxes do not contain each of our messages

                recipientmessages.unshift(messageObj)
                mymessages.unshift(mymessageObj)
                sendmessage2(recipientmessages, mymessages);
            }

        }

    }


    //send message
    const sendmessage2 = (recipientmessages, mymessages) => {
        axios.post(Postmessagesurl, {
            email1: Details.email,
            messages1: recipientmessages,
            email2: mydetails.email,
            messages2: mymessages

        }).then(response => {
            setloading(false)
            if (!response.data.message) {
                if (response.data.success) {
                    getupdatedrecipientsmessages();
                } else {
                    setloading(false)
                    seterror("There was an internal error contact admin")
                }
            } else {
                setloading(false)
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("There was an error try again later")

        });
    }


    const getupdatedrecipientsmessages = () => {
        axios.post(Fetchmessagesurl, {
            email: mydetails.email
        }).then(response => {
            if (!response.data.message) {
                if (response.data.messages) {
                    var index = response.data.messages.findIndex(obj => obj?.email == Details.email && obj.deletestatus !== "true");
                    setdisplayedmessages(response.data.messages[index].messages)
                    setsuccess(true)
                    setmessage("")
                    scrollToBottom()
                    //  mygetmessages(response.data.messages)
                } else {
                }
            } else {
            }
            // 
        }).catch(error => {

        });

    }






    const messagesEndRef = useRef(null)

    const scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
    }

    return (
        <div className={styles.container}>
           
            <div className={styles.topheader} style={{ paddingBottom: 100 }}>
                <Universalheader />
                <div className={styles.advertisediv}>
                    <FaStarOfLife color={primarycolor} size={15} />
                    <Link style={{ textDecoration: "none" }} to="">
                        <a href="https://play.google.com/store/apps/details?id=com.eazistey.eazistey">List on Eazistey</a>
                    </Link>
                </div>
                <div className={styles.housenamediv}>
                    <div className={styles.housenamehead}>{user?.username}</div>
                    <div>

                    </div>
                </div>
                <div className={styles.linksdiv}>
                    <Link to="/nav" style={{ textDecoration: "none" }}>
                        <a>Home  /</a>
                    </Link>

                    <a onClick={() => navigate(-1)} style={{ cursor: "pointer", textDecoration: "none" }}>Back  /</a>
                    <a onClick={() => {
                        setallmessages(true)
                        setstartchat(false)
                        setshowsingleconversation(false)
                    }} style={{ cursor: "pointer" }}>chats</a>
                </div>
                <div className={styles.bodydiv}>
                   
                    <div className={styles.housedetailsdiv}>
                        {startchat &&
                            <div className={styless.messagediv}>
                                <div className={styless.timediv}>{time}</div>
                                <div style={{ fontSize: 15, fontWeight: "bold" }}>Start chat with {sessionhouse.username}</div>
                                <br />
                                <label>Type your message : </label><br />
                                <textarea name="Text1" cols="35" rows="7"
                                    onChange={(e) => setmessage(e.target.value)}
                                    value={message}
                                /><br />
                                {error && <div style={{ fontSize: 10, color: "red" }}>{error}</div>}
                                <button className={styless.sendbtn} onClick={check}><FaForward />  {loading ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Send"}</button>
                            </div>
                        }{allmessages &&
                            <div>
                                <div className={styless.timediv}>{time}</div>
                                <div style={{ fontSize: 15, fontWeight: "bold" }}>My messages</div>
                                <br />
                                {loading &&
                                    <div>
                                        <ReactLoading type={type} color={color} height={25} width={20} />
                                    </div>
                                }
                                <div className={styless.allmessagesdiv}  >
                                    {Array.isArray(fetchedmessages) && fetchedmessages.map((val, key) => {
                                        return (
                                            val.deletestatus !== "true" &&
                                            <div className={styless.singlemessagediv} onClick={() => {
                                                setallmessages(false)
                                                setstartchat(false)
                                                setshowsingleconversation(true)
                                                setDetails(val)
                                                setdisplayedmessages(val.messages)
                                                readmessage();
                                                setTimeout(() => {
                                                    scrollToBottom();
                                                }, 3000);
                                            }}>
                                                {val.url ? <div>
                                                    <img src={val.url} style={{ height: 50, width: 50, borderRadius: 50 }} />
                                                </div> : <div className={styless.initialdiv}>{val.username?.substring(0, 1)}</div>}
                                                <div className={styless.messagecontentdiv}>
                                                    <div style={{ fontWeight: "bold" }}>{val?.username}</div>
                                                    {val.messages.length == 1 ? val.messages[0].message?.substring(0, 25) :
                                                        val.messages[val.messages.length - 1].message?.substring(0, 30)}
                                                </div>
                                                <div className={styless.messagetimediv}>
                                                    {val.messages.length == 1 ? val.messages[0].time :
                                                        val.messages[val.messages.length - 1].time} <br />
                                                    {val.messages.length == 1 ? val.messages[0].date === date ? "Today" : val.messages[0].date :
                                                        val.messages[val.messages.length - 1].date === date ? "Today" : val.messages[val.messages.length - 1].date}

                                                </div>

                                            </div>
                                        )
                                    })
                                    }
                                </div>
                                {error &&
                                    <div className={styless.errordiv2}><div style={{ color: "red", fontSize: 10 }}>{error}</div> </div>
                                }
                            </div>
                        }
                        {
                            showsingleconversation &&
                            <div> <div className={styless.timediv}><FaPhoneAlt color={primarycolor} style={{ cursor: "pointer" }} /></div>
                                <div style={{ fontSize: 15, fontWeight: "bold" }}>Chatting with {Details?.username}</div>
                                <br />
                                <div className={styless.allmessagesdiv} >
                                    {
                                        displayedmessages?.map((val, key) => {

                                            return (
                                                val.designation !== "me" ?
                                                    <div className={styless.cllentmessagediv}>
                                                        {val.message}
                                                    </div> :
                                                    <div className={styless.sendermessagediv} ref={messagesEndRef}>
                                                        {val.message}
                                                    </div>
                                            )
                                        })
                                    }
                                    <div />

                                </div>
                                <div className={styless.messagediv}>
                                    <label>Reply to message: </label><br />
                                    <textarea name="Text1" cols="40" rows="7"
                                        onChange={(e) => setmessage(e.target.value)}
                                        value={message}
                                    /><br />
                                    {success && <div style={{ fontSize: 10, color: "green" }}>message sent</div>}
                                    {error && <div style={{ fontSize: 10, color: "red" }}>{error}</div>}
                                    <button className={styless.sendbtn} onClick={check2}><FaForward />  {loading ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Send"}</button>
                                </div>

                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Chats;